module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-invalid.8fdf27c4.png";